module.exports = __webpack_public_path__ + "01a9f39134a05dc8eff95f612e7f92ca.woff2";